// removed by extract-text-webpack-plugin
module.exports = {"clientResultsScoreTitle":"_2tS3ya9CHKISykq1sHg8Dn","clientResultsScore":"_2UW9GrI6nRzvphR6_swbQO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/ClientModel.css
// module id = 1093
// module chunks = 0